export default __webpack_public_path__ + "static/Rezept-Upload-iade-51a5dedd6b31a743d314cfb304ca8dad.svg";